module.exports = __webpack_public_path__ + "static/media/oHatch.e2381d47.jpeg";